import { Map } from 'immutable'
import _ from 'lodash'
import { mergeComponentReducers } from 'gnos-utilities/reducer'

import config from '../../../../../../config'

import { SET_PORTFOLIO_MODULE_ACCESS_RIGHTS } from '../../constants'

import buttonsArrayReducer from '../../../../components/Ribbon/components/ButtonsArray/reducer'
import dropDownReducer from '../../../../components/Ribbon/components/DropDown/reducer'

import { DROPDOWN_KEY, BUTTONSARRAY_KEY } from './constants'

const settings = {
    module: config.modules.portfolio.key,
    components: {
        arrayName: buttonsArrayReducer,
        dropDownName: dropDownReducer,
    },
}

// No need initial state, because of mergeComponentReducers (initial state is Map)
function ribbonReducer(state = Map(), action = {}) {
    switch (action.type) {
        case SET_PORTFOLIO_MODULE_ACCESS_RIGHTS: {
            const defaultActiveType = _.get(action, 'data.accessRights.defaultType', null)

            const typeBlocks = _.get(action, `data.accessRights.types.${defaultActiveType}.blocks`, [])
            const transformedBlocksData = _.reduce(
                typeBlocks,
                (acc, block) => ({
                    ...acc,
                    [block.name]: !block.isDisabled, // if disabled, button isn't active
                }),
                {}
            )

            return state
                .setIn([BUTTONSARRAY_KEY, 'data'], Map(transformedBlocksData))
                .setIn([DROPDOWN_KEY, 'active'], defaultActiveType)
                .setIn([DROPDOWN_KEY, 'selected'], true)
        }
        default:
            return state
    }
}

export default mergeComponentReducers(ribbonReducer, settings)
